const global = window

// Support de conditions d'affichages
inputs.behavior.cond = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.cond) {
        // fix data
        if (!(data.cond instanceof Array)) {
            data.cond = [data.cond]
        }

        if (!(data.cond[0] instanceof Array)) {
            data.cond = [data.cond]
        }

        if (!(data.cond[0] instanceof Array)) {
            data.cond = [data.cond]
        }

        // find fields
        const fields = {}
        $.each(data.cond, function (index, groupOr) {
            $.each(groupOr, function (indexb, groupAnd) {
                if (typeof groupAnd == 'string') {
                    const parseCond = groupAnd.split(' ')
                    data.cond[index][indexb] = groupAnd = {
                        field: parseCond[0],
                        operator: parseCond[1],
                        val: parseCond[2],
                    }
                }
                else if (groupAnd[0], groupAnd[1], groupAnd[2]) {
                    data.cond[index][indexb] = groupAnd = {
                        field: groupAnd[0],
                        operator: groupAnd[1],
                        val: groupAnd[2],
                    }
                }
                else {
                    if (groupAnd.val === undefined && groupAnd.value !== undefined) {
                        groupAnd.val = groupAnd.value
                    }
                }
                // console.log(groupAnd);

                fields[groupAnd.field] = groupAnd.field
            })
        })

        data.applyCond = function (changedField) {
            changedField = $(changedField)
            const pf = changedField.closest('[data-api], .window, body')
            let testOr = false
            $.each(data.cond, function (index, groupOr) {
                let testAnd = true

                $.each(groupOr, function (index, groupAnd) {
                    const debugFieldName = '__DISABLED';
                    
                    let value
                    value = global.getFieldData(groupAnd.field, pf)

                    if (groupAnd.field == debugFieldName) {
                        console.log('-------------');
                        console.log(groupAnd);
                        console.log(value);
                        console.log(global.getFormData(pf));
                    }
                    
                    let testCond = 0

                    // fix val data
                    if (groupAnd.val === undefined && groupAnd.value !== undefined) {
                        groupAnd.val = groupAnd.value
                    }
                    if (typeof groupAnd.val != 'object' || groupAnd.val === null) {
                        groupAnd.val = [groupAnd.val]
                    }

                    // Undefined value
                    if (value == undefined || value === '') {
                        value = null;
                    }

                    if (groupAnd.field == debugFieldName) {
                        console.log('field');
                        console.log(value);
                        console.log('require');
                        console.log(groupAnd.val);
                    }

                    // tests data
                    $.each(groupAnd.val, function (i2, testVal) {
                        if (testVal === '') testVal = null;


                        if (groupAnd.field == debugFieldName) {
                            console.log('real test');
                            console.log(testVal);
                        }

                        switch (groupAnd.operator) {
                        case '>':
                            if (value <= testVal) testCond = -1
                            break
                        case '<':
                            if (value >= testVal) testCond = -1
                            break
                        case '>=':
                            if (value < testVal) testCond = -1
                            break
                        case '<=':
                            if (value > testVal) testCond = -1
                            break
                        case '!=':
                            if (value == testVal) testCond = -1
                            break
                        case '==':
                        default:
                            if (value == testVal) testCond = 1
                        }
                    })

                    if (testCond == 0) {
                        if (groupAnd.operator == '==') testCond = -1
                        else testCond = 1
                    }
                    
                    if (groupAnd.field == debugFieldName) {
                        console.log(testCond);
                    }

                    // one test fail, the and test fail
                    if (testCond == -1) testAnd = false
                })

                // one test success, the or test success
                if (testAnd) testOr = true
            })

            // apply state
            let needChange = false;
            if (testOr) {
                // console.log('show '+niceName);
                if (input.is(':disabled') || input.hasClass('disabled')) needChange = true
                if (!data.disabled) {
                    input.removeAttr('disabled').removeClass('disabled');
                    parent.find('.xdsoft_disabled').removeClass('xdsoft_disabled');
                }
                if (!input.hasClass('tabs__pane')) {
                    input.show()
                }
                input.removeClass('hidden');
                pf.find('.col--label--' + niceName).show()
                pf.find('.col--field--' + niceName).show()
                pf.find('.' + niceName + '-tab').show().css('display', 'inline-block').removeClass('hidden')
                if (
                    pf.find('.' + niceName + '-tab').length
                    && pf.find('.' + niceName + '-tab li').length > 1
                ) {
                    pf.find('.' + niceName).hide()
                }
            } else {
                // console.log('hide '+niceName);
                if (!input.is(':disabled') && !input.hasClass('disabled')) needChange = true
                input.attr('disabled', 'disabled').addClass('disabled');
                if (data.condEffect != 'disabled') {
                    if (!input.hasClass('tabs__pane')) {
                        input.hide()
                    }
                    input.addClass('hidden');
                    pf.find('.col--label--' + niceName).hide()
                    pf.find('.col--field--' + niceName).hide()
                    pf.find('.' + niceName + '-tab').hide().addClass('hidden')
                }
                if (pf.find('.' + niceName + '-tab').hasClass('ui-tabs-active')) {
                    inputs.fn.tabs.set(pf.find('.' + niceName + '-tab').closest('.tabs'), pf.find('.' + niceName + '-tab').parent().find('> li').not('.ui-tabs-active').first());
                }
                if (pf.find('.' + niceName + '-tab').hasClass('steps__btn')) pf.find('.' + niceName + '-tab').show();
            }
            if (needChange && input) {
                input.change();
            }
        }

        data.condBinding = function(target) {
        $.each(fields, function (index, field) {
                let inputTarget = target.find('[data-id="' + field + '"]')
	            inputTarget.change(function () {
	                data.applyCond(this)
	            }).keyup(function () {
	                global.noQ = true;
	                inputTarget.data('noQ', true);
	                data.applyCond(this)
	                inputTarget.removeData('noQ');
	                global.noQ = false;
	            })
	            global.noQ = true;
	            inputTarget.data('noQ', true);
	            inputTarget.change()
	            inputTarget.removeData('noQ');
	            global.noQ = false;
	        })
        }

        data.condBinding(inputWindow);
        BEHAV.add(data.condBinding, inputWindow.data('behavkey'));
    }
    return data
}
